var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"BUTTON",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',{staticClass:"TEXT"},[_vm._v("Filter")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }